import { Avatar, AvatarFallback, AvatarImage } from '@radix-ui/react-avatar';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useRef } from 'react';
import { z } from 'zod';
import ActionButton from '@/components/Button/ActionButton';
import { AttributeCard } from '@/components/Card/AttributeCard';
import Icon from '@/components/Icon/Icon';
import { HStack, Spacer, VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { Confetti, type ConfettiRef } from '@/components/ui/confetti';
import { useAuthStore } from '@/lib/auth';
import { defaultNS, useTranslation } from '@/lib/i18n';
const CompletedSchema = z.object({
  addedItemID: z.string()
});
export const Route = createFileRoute('/_staff/item-ledger/add/completed')({
  validateSearch: zodValidator(CompletedSchema),
  loaderDeps: ({
    search
  }) => ({
    search
  }),
  component: () => <Completed />
});
function Completed() {
  const confettiRef = useRef<ConfettiRef>(null);
  const {
    session
  } = useAuthStore();
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.itemLedger'
  });
  const {
    search
  } = Route.useLoaderDeps();
  const navigate = useNavigate();
  return <VStack className="flex items-center justify-center">
      <Confetti ref={confettiRef} />
      <AttributeCard title={t('completedTitle')} className="w-2/4 p-4" actionButton={<ActionButton variant="secondary" onClick={() => {
      navigate({
        to: '/item-ledger/$itemId',
        params: {
          itemId: search.addedItemID
        }
      });
    }}>
            {t('actionGoToItemDetail')}
          </ActionButton>}>
        <VStack>
          <Text variant="h3">{t('completedMessage')}</Text>
          <Spacer />
          <HStack className="items-center">
            <Icon iconName="SquareCheckBig" text={t('completedByLabel')} />
            <Spacer />
            <Avatar className="grid size-8 place-items-center">
              <AvatarImage src={session?.person.avatarUrl} />
              <AvatarFallback>
                <Icon iconName="UserRoundIcon" />
              </AvatarFallback>
            </Avatar>
            <Spacer />
            {session?.person?.name}
          </HStack>
        </VStack>
      </AttributeCard>
      <Spacer variant="xl" />
      <ActionButton variant="ghost" onClick={() => {
      navigate({
        to: '/item-ledger/add'
      });
    }} icon="PlusIcon" iconColor="active">
        {t('continueAdding')}
      </ActionButton>
    </VStack>;
}